import { render, staticRenderFns } from "./printPostedPaymentsModal.vue?vue&type=template&id=7b312dca&"
import script from "./printPostedPaymentsModal.vue?vue&type=script&lang=js&"
export * from "./printPostedPaymentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports